import { __awaiter, __generator } from "tslib";
import { createToggleDriver } from '../../primitives/drivers';
import { floaterMenuKey } from './floater-menu';
export var createFloaterMenuDriver = function (wrapper) {
    var base = wrapper.$("." + floaterMenuKey);
    var select = function (idx) { return base.$$('.menu-item').get(idx).click(); };
    return {
        getItemsCount: function () { return base.$$('.menu-item').count(); },
        getItems: function () { return base.$$('.menu-item').text(); },
        getItemValues: function () { return base.$$('.menu-item').map(function (e) { return e.attr('data-value'); }); },
        select: select,
        selectByClass: function (className) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.$(".menu-item." + className).click()];
        }); }); },
        selectByValue: function (val) { return __awaiter(void 0, void 0, void 0, function () {
            var baseDrivers;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, base.$$('.menu-item')];
                    case 1:
                        baseDrivers = _a.sent();
                        return [4 /*yield*/, baseDrivers.filter(function (d) { return __awaiter(void 0, void 0, void 0, function () {
                                var value;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, d.attr('data-value')];
                                        case 1:
                                            value = _a.sent();
                                            return [2 /*return*/, value === val];
                                    }
                                });
                            }); })
                                .get(0)
                                .click()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        disabled: function (idx) { return base.$$('.menu-item').get(idx).hasClass('disabled'); },
        toggle: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, createToggleDriver(base.$('.menu-item-section-heading')).toggle()];
        }); }); },
        hasAlert: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.$('.alert').exists()];
        }); }); },
        getSubtitle: function (idx) { return base.$$('.menu-item-subtitle').get(idx).text(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map